module.exports = [
  'General Appearance',
  'Nutrition',
  'Skin',
  'Head, Neck & Nodes',
  'Eyes/Eq. Reflex',
  'ENT/Hearing',
  'Mouth/Dental',
  'Chest/Lungs',
  'Heart',
  'Abdomen',
  'Ext. Genitalia',
  'Back',
  'Extremities/Hips',
  'Neurological',
  'Fem. Pulses',
];



// WEBPACK FOOTER //
// ./client/src/components/patientPages/wellChildCheck/physicalExaminationItems.js